import { render, staticRenderFns } from "./allCategoriesDialog.vue?vue&type=template&id=fbe059c0&scoped=true"
import script from "./allCategoriesDialog.vue?vue&type=script&lang=js"
export * from "./allCategoriesDialog.vue?vue&type=script&lang=js"
import style0 from "./allCategoriesDialog.vue?vue&type=style&index=0&id=fbe059c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe059c0",
  null
  
)

export default component.exports